import { useAppDispatch, useAppSelectorShallow } from 'store/hooks';
import Switch from 'components/ui/Switch';
import Card from 'components/ui/Card';
import InfoCircle from 'assets/icons/InfoCircle';
import COLOR from 'constants/color';
import { MODAL_TYPES } from 'constants/general';
import { ATTRIB } from 'constants/test';
import { t } from 'services/i18n.service';
import { moreOptionModalActivitySelector } from 'store/reducer/modal/more-options.modal.selectors';
import { updateConfirmActionModal } from 'store/reducer/modal/slice';

const IncludeInEveryBreak: React.FC = () => {
  const dispatch = useAppDispatch();
  const activity = useAppSelectorShallow(moreOptionModalActivitySelector);

  const handleToggle = (checked: boolean) => {
    dispatch(
      updateConfirmActionModal({
        showConfirmModal: true,
        modalType: MODAL_TYPES.CONFIRM_INCLUDE_IN_EVERY_BREAK,
        confirmTitle: t('continue'),
        cancelTitle: t('btn_cancel'),
        description: t('include_in_every_break_confirmation'),
        data: checked
      })
    );
  };

  return (
    <Card className='flex flex-col ~gap-3/4'>
      <div className='flex items-center ~gap-3/6'>
        <h3 className='~text-xs/base font-semibold text-black dark:text-white'>
          {t('include_in_every_break')}
        </h3>
        <Switch
          checked={activity?.include_in_every_break ?? false}
          onChange={handleToggle}
          size='medium'
          variant='default'
          data-testid={ATTRIB.TEST.SWITCH_INCLUDE_IN_EVERY_BREAK}
        />
      </div>
      <div className='flex items-start ~gap-1.5/2'>
        <InfoCircle
          styles='~w-3.5/4 ~h-3.5/4 flex-shrink-0 mt-0.5'
          fill={COLOR.SEMANTIC.INFO_SOFT}
        />
        <p className='~text-xs/sm text-gray-600 dark:text-gray-400'>
          {t('include_in_every_break_tooltip')}
        </p>
      </div>
    </Card>
  );
};

export default IncludeInEveryBreak;
